import { fetchCurrentUser } from '~/domains/auth/queries';
import type { CART_TYPE } from '~/hooks/useCartTypeParam';
import { logError } from '~/utils/datadog';

import { CHECKOUT_ROUTER } from '../router';

/**
 * 주문서 가기 전 추천상품 페이지 이동을 위한 Route 함수
 * 바로구매시(QUICK) -> 구매 여부에 따라 분기추가
 * 장바구니 -> 추천 페이지 이동
 * */
export const getCheckoutBeforeRecommendRoute = async (type: CART_TYPE) => {
  const data = await fetchCurrentUser();

  switch (type) {
    case 'QUICK':
      return CHECKOUT_ROUTER.quick;
    // 24.06.24 - 바로 구매시에는 주문서 페이지로 바로 이동하도록 임시 처리함.

    // 주문을 한번도 안했다면 바로 주문서로 이동함.
    // return !data.isOrdered ? CHECKOUT_QUICK : RECOMMEND_CHECKOUT_QUICK;
    case 'SHOPPING_CART':
      return !data.isOrdered
        ? CHECKOUT_ROUTER.newUserRecommend('SHOPPING_CART')
        : CHECKOUT_ROUTER.recommend('SHOPPING_CART');
    default:
      logError(
        new Error(
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `Cannot parse getCheckoutBeforeRecommendRoute ${type as unknown}`,
        ),
      );
      return CHECKOUT_ROUTER.recommend('SHOPPING_CART');
  }
};
